<template>
  <div class="save">
    <save-page-header title="Genre"></save-page-header>
    <el-form
      class="mt-30"
      :label-width="labelWidth + 'px'"
      @submit.prevent.native=""
    >
      <translatable-input
        :errors="errors"
        :source.sync="form.names"
        sourceKey="names"
        placeholder="New genre"
        title="Name"
        :label-width="labelWidth"
      />

      <el-form-item label="Color" class="with-label-as-translatable">
        <el-color-picker v-model="form.color"></el-color-picker>
      </el-form-item>

      <div class="align-right">
        <el-col :span="4">
          <el-button
            native-type="submit"
            :loading="saveGenreLoading"
            type="primary"
            plain
            class="plain-primary"
            @click="submit"
          >
            {{ isUpdate ? 'Save Genre' : 'Create Genre' }}
          </el-button>
        </el-col>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { apiError, labelWidth } from '@/mixins'
import TranslatableInput from '@/components/Form/TranslatableInput'
import { initMultilingual } from '@/services/helpers'
import SavePageHeader from '@/components/ui/SavePageHeader'
export default {
  components: {
    TranslatableInput,
    SavePageHeader,
  },
  mixins: [apiError('saveGenreError'), labelWidth],
  data: () => ({
    form: {
      names: initMultilingual(),
    },
  }),
  computed: {
    ...mapState('genre', ['genre', 'saveGenreError', 'saveGenreLoading']),
    isUpdate() {
      return this.$route.params.id !== undefined
    },
  },
  async mounted() {
    if (this.isUpdate) {
      await this.getGenre({
        routeParameters: {
          id: this.$route.params.id,
        },
      })
      this.form = {
        ...this.genre.data,
        names: initMultilingual(this.genre.data.names),
      }
    }
  },
  methods: {
    ...mapActions('genre', ['saveGenre', 'getGenre']),
    async submit() {
      await this.saveGenre({
        routeParameters: {
          id: this.$route.params.id,
        },
        ...this.form,
      })
    },
  },
}
</script>
